<template>
  <v-container fluid>
    <h3 class="mb-5">Užsakymai iš savitarnos įvykdyti PAS'e</h3>

    <div
      class="dataContainer mb-5"
      @keydown.enter.prevent="getData()"
      @keydown.esc.prevent="cancelData()"
    >
      <el-overlay-loading :loading="loading" />

      <template v-if="showError">
        <v-row>
          <v-col cols="12">
            <v-alert dense outlined type="error">
              Klaida
              <div>
                {{ errorMsg }}
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </template>

      <v-row class="mt-5">
        <v-col cols="12" md="6">
          <el-text-field
            label="PAS prašymo numeris"
            tooltip="Administravimas. PAS. PAS prašymo numeris"
            v-model="pas_nr"
          />
        </v-col>
        <v-col cols="12" md="6">
          <el-text-field
            label="NEP prašymo / Paieškos numeris"
            tooltip="Administravimas. PAS. Paieškos numeris"
            v-model="turtas_nr"
          />
        </v-col>
        <v-col cols="12" md="12">
          <el-button primary @click.native="getData()" :loading="loading"
            >Ieškoti</el-button
          >
          <el-button @click.native="cancelData()" :loading="loading"
            >Išvalyti</el-button
          >
        </v-col>
      </v-row>
    </div>

    <template v-if="showResults">
      <v-data-table
        :headers="filteredHeaders"
        :items="filteredItemsList"
        :loading="loading"
        hide-default-footer
      >
        <template #[`item.turtas_busena_pav`]="{ item }">
          <el-busena :busena="item.turtas_busena_pav" />
        </template>
        <template #[`item.actions`]="{ item }">
          <el-button
            v-if="item.turtas_action"
            primary
            @click.native="submitItem(item)"
            :loading="loading"
          >
            {{ item.keisti_button }}
          </el-button>
        </template>
        <template slot="loading">
          Kraunasi...
        </template>
        <template slot="no-results">
          Duomenų nėra
        </template>
        <template slot="no-data">
          Duomenų nėra
        </template>
      </v-data-table>
    </template>

    <modal-pas-tvarkymas
      :item="confirmItem"
      v-model="showConfirm"
      @confirm="submitConfirm"
      @cancel="cancelConfirm"
    />
  </v-container>
</template>

<script>
import ModalConfirm from '../modals/ModalConfirm'
import ModalPasTvarkymas from '../modals/ModalPasTvarkymas'

export default {
  name: 'AdminPasTvarkymas',
  components: {
    ModalPasTvarkymas,
  },
  data() {
    return {
      loading: false,
      pas_nr: null,
      turtas_nr: null,
      errorMsg: null,
      showError: false,
      showResults: false,
      prasymai: [],
      showConfirm: false,
      confirmItem: null,
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    headers() {
      return [
        {
          text: 'Prašymo / paieškos numeris',
          align: 'start',
          sortable: false,
          value: 'turtas_nr',
        },
        {
          text: 'PAS prašymo numeris',
          align: 'start',
          sortable: false,
          value: 'pas_nr',
        },
        {
          text: 'PAS prašymo būsena',
          align: 'start',
          sortable: false,
          value: 'pas_busena',
        },
        {
          text: 'PAS darbo būsena',
          align: 'start',
          sortable: false,
          value: 'pas_darbas_busena',
        },
        {
          text: 'Paslaugos pavadinimas',
          align: 'start',
          sortable: false,
          value: 'pas_pavadinimas',
        },
        {
          text: "Užsakymo būsena TURT'e",
          align: 'start',
          sortable: false,
          value: 'turtas_busena_pav',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      return this.itemsList.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.prasymai.map(item => {
        let turtas_tipas_pav = null
        let turtas_action = false
        let keisti_pas = false
        let keisti_button = null

        if (item.turtas_nr) {
          turtas_tipas_pav =
            item.turtas_tipas === 'prasymas' ? 'Prašymas' : 'Paieška'

          turtas_action =
            (item.turtas_tipas === 'prasymas' &&
              item.turtas_busena === 'perduotas') ||
            (item.turtas_tipas === 'paieska' &&
              item.turtas_busena === 'laukia_patvirtinimo')

          keisti_pas = !item.pas_busena.includes(['Įvykdytas', 'Atmestas'])
          keisti_button =
            item.turtas_tipas === 'prasymas'
              ? 'Keisti į nutrauktas'
              : 'Keisti į atmestas'
        }

        item.turtas_tipas_pav = turtas_tipas_pav
        item.turtas_action = turtas_action
        item.keisti_pas = keisti_pas
        item.keisti_button = keisti_button
        return item
      })
    },
  },
  created() {
    if (this.isLocal) {
      this.turtas_nr = 1741140211
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.showError = false
      this.showResults = false

      let data = {
        pas_nr: this.pas_nr,
        turtas_nr: this.turtas_nr,
      }

      this.$axios
        .post(`admin/pas-tvarkymas/sarasas`, data)
        .then(res => {
          this.prasymai = res.data.prasymai
          this.showResults = true
        })
        .catch(err => {
          this.errorMsg = err.response.data.message
          this.showError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.showError = false
      this.pas_nr = null
      this.turtas_nr = null
    },
    submitItem(item) {
      this.loading = true
      this.confirmTitle = `Keisti į ${
        item.turtas_tipas === 'prasymas' ? 'nutrauktas' : 'atmestas'
      }`
      this.confirmText = `Ar tikrai norite programoje TURTAS paslaugos
                          <b>${item.turtas_tipas_pav} Nr. ${item.turtas_nr}</b>
                          būseną keisti į "${
                            item.turtas_tipas === 'prasymas'
                              ? 'Nutrauktas'
                              : 'Atmestas'
                          }"? `
      this.confirmItem = item
      this.showConfirm = true
    },
    submitConfirm(item, priezastis) {
      this.showConfirm = false
      this.showError = false

      let data = {
        turtas_nr: item.turtas_nr,
        turtas_tipas: item.turtas_tipas,
        keisti_pas: item.keisti_pas,
        priezastis: priezastis,
      }

      this.$axios
        .post(`admin/pas-tvarkymas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          this.errorMsg = err.response.data.message
          this.showError = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelConfirm() {
      this.showConfirm = false
      this.loading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
